import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { validatable } from 'components/utils';
import { DuLieuHeThong } from 'api';

class DropDownChonNhomThamQuyenGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getNhomThamQuyenCombobox.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'nhomThamQuyenGiaiQuyet',
            data: res.data && res.data._embedded && res.data._embedded.thamQuyenGiaiQuyets ? res.data._embedded.thamQuyenGiaiQuyets : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }
  
  render() {
    const filterDataThamQuyen = (data) => {
      if (this.props.filterThamQuyenGiaiQuyet) {
        const newData = data.filter(item => (item.ten === 'Khác' || item.ten === 'Hành chính'));
        const result = newData.map(item => {
          if (item.ten === 'Hành chính') {
            return {
              ...item,
              ten: 'Đơn vị trong hệ thống',
              moTa: 'Đơn vị trong hệ thống'
            };
          }
          return item;
        })
        return result;
      }
      return data 
    }
    const getLabel = () => {
      if (this.props.filterThamQuyenGiaiQuyet) {
        return 'Đơn vị nhận'
      }
      return this.props.label
    }
    return (
      <DropDown
        checkValidate = {this.props.checkValidate}
        bindValidator={this}
        channel="formTaoDon"
        isValid={this.props.isValid}
        require={this.props.require}
        selectedValue={this.props.selectedValue}
        label={getLabel()}
        options={ filterDataThamQuyen(this.state.data) }
        keyName='thamQuyenGiaiQuyetId'
        valueName='ten'
        onChange={ this.onChange.bind(this) }
        placeholder={ this.props.placeholder }
        className={this.props.className}
        name={this.props.name}
      />
    )
  }
}

DropDownChonNhomThamQuyenGiaiQuyet.defaultProps = {
  label: "Nhóm thẩm quyền đã giải quyết",
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name:'',
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.nhomThamQuyenGiaiQuyet
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonNhomThamQuyenGiaiQuyet));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonnhomthamquyengiaiquyet.jsx